<template>
  <section>
    <el-form :model="formObj" :rules="fromRules" ref="formObj" label-width="120px">
      <el-form-item label="上级岗位">
        <div v-if="isShowTree">
          <LinkageRole @roleSelected="roleSelected" :com-name="formData.parentComName" :com-id="formData.parentComId" :pro-id="formData.parentProId" :role-id="formObj.parentId"
                       :role-name="formObj.parentName" :role-current-id="formObj.id" :option="option"></LinkageRole>
        </div>
      </el-form-item>
      <el-form-item label="所属公司" prop="comId">
          <CompanyList @comSelected="comSelected" :option="option" :com-name="formData.comName" :com-id="formData.comId"></CompanyList>
      </el-form-item>
      <el-form-item label="所属项目">
        <el-select clearable v-model="proId" placeholder="请选择项目" @clear="proClear">
          <el-option v-for="(item,index) in proData" :key="item.id" :label="item.proName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="岗位名称" prop="roleName">
        <el-input v-model="formObj.roleName" placeholder="请输入" maxlength="10" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="岗位描述" prop="roleDesc">
        <el-input type="textarea" v-model="formObj.roleDesc" placeholder="请输入" maxlength="100"
                  show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="是否管理岗位" prop="isManager">
        <el-radio v-model="isManager" label="1" >是</el-radio>
        <el-radio v-model="isManager" label="0" >否</el-radio>
      </el-form-item>
      <el-form-item label="标记" prop="status">
        <el-select v-model="status">
          <el-option label="系统管理员" value="-1"></el-option>
          <el-option label="项目经理" value="0"></el-option>
          <el-option label="工种" value="1"></el-option>
          <el-option label="班组" value="2"></el-option>
          <el-option label="部门" value="3"></el-option>
          <el-option label="安全员" value="4"></el-option>
          <el-option label="质量员" value="5"></el-option>
          <el-option label="施工员" value="6"></el-option>
          <el-option label="技术员" value="7"></el-option>
          <el-option label="资料员" value="8"></el-option>
          <el-option label="仓库" value="9"></el-option>
          <el-option label="塔吊司机" value="10"></el-option>
          <el-option label="塔吊指挥" value="11"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="功能" prop="funs">
        <el-row>
          <el-col>
            <el-tree :data="funData"
                     :props="defaultProps"
                     :load="loadNode1"
                     :default-expand-all="true" lazy
                     :node-key="defaultProps.value"
                     :expand-on-click-node="false"
                     :default-expanded-keys="defaultExpandedKey"
            >
                       <span slot-scope="{ node, data }" >
                          <span>{{node.label }}</span>
                          <span v-if="option==0">
                            <span class="space" v-if="data.funOption!=null && data.funOption!=''">
                              <el-checkbox v-for="(item,index) in data.funOption.split(',')" :key="index"
                                           @change="function handleChange(v){
                                              appendFun(v,data,item);
                                           }">
                              {{item=='c'?'添加':item=='u'?'修改':item=='r'?'查询':item=='d'?'删除':item=='m'?'详情':item=='s'?'更改状态':item=='p'?'对比':''}}
                              </el-checkbox>
                            </span>
                         </span>

                          <span v-if="option==1">
                            <span v-if="data.funOption!=null && data.funOption!=''">

                              <span v-for="(item,index) in data.funOption.split(',')"
                                    v-if="tempList.indexOf(data.keyCode)>-1"
                                    class="space">
                                <el-checkbox   v-for="(t,n) in tempFunOptionList"
                                              :key="n"
                                               v-if="t.keyCode == data.keyCode && t.option.indexOf(item)>-1"
                                               checked
                                               @change="function handleChange(v){
                                                appendFun(v,data,item);
                                             }">
                                 {{item=='c'?'添加':item=='u'?'修改':item=='r'?'查询':item=='d'?'删除':item=='m'?'详情':item=='s'?'更改状态':item=='p'?'对比':''}}
                                </el-checkbox>
                                 <el-checkbox   v-for="(t,n) in tempFunOptionList"
                                                :key="n"
                                                v-if="t.keyCode == data.keyCode && t.option.indexOf(item)<=-1"
                                                @change="function handleChange(v){
                                                appendFun(v,data,item);
                                             }">
                                 {{item=='c'?'添加':item=='u'?'修改':item=='r'?'查询':item=='d'?'删除':item=='m'?'详情':item=='s'?'更改状态':item=='p'?'对比':''}}
                                </el-checkbox>
                              </span>
                              <span v-for="(item,index) in data.funOption.split(',')"
                                    v-if="tempList.indexOf(data.keyCode)<=-1"
                                    class="space">
                                <el-checkbox  :key="index" ref="OP"
                                              @change="function handleChange(v){
                                                appendFun(v,data,item);
                                             }">
                                  {{item=='c'?'添加':item=='u'?'修改':item=='r'?'查询':item=='d'?'删除':item=='m'?'详情':item=='s'?'更改状态':item=='p'?'对比':''}}
                                </el-checkbox>
                              </span>
                            </span>
                          </span>
                       </span>
            </el-tree>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="doCancel">取消</el-button>
      <el-button type="primary" @click.native="doSubmit(option)">确定</el-button>
    </div>
  </section>
</template>

<script>
  import {roleCreate, roleUpdate, funs,proSearch} from '../../api/api'
  import LinkageRole from "./LinkageRole";
  import CompanyList from "./CompanyList";

  export default {
    name: "ProjectForm",
    components: {LinkageRole,CompanyList},
    props: {
      option: 0,
      formData: {}
    },
    data() {
      return {
        formObj: {},//如果不选择上级公司默认为总公司
        fromRules: {
          comId: [
            {required: true, message: '请选择公司', trigger: 'blur'}
          ],
          roleName: [
            {required: true, message: '请输入项目名称', trigger: 'blur'}
          ],
          // funs: [
          //   {required: true, message: '请选择功能/操作', trigger: 'blur'},
          //   { min: 3, message: '至少选择一个功能', trigger: 'blur' }
          // ],
          status: [
            {required: true, message: '请选择分类', trigger: 'blur'},
          ],
        },
        isShowTree: false,
        funData: [],
        defaultProps: {
          children: 'children',
          label:
            'funName',
          value:
            'funId',
        },
        defaultExpandedKey: [],
        parentName: null,
        linkObj: {},
        funOptionList: [],
        tempList:[],
        //中间接收值
        comId:null,
        proId:null,
        parentId: null,
        isManager:null,
        status:'-1',
        proData: [],
        tempFunOptionList:[]
      }
    },
    methods: {
      comSelected: function (id) {
        this.comId = id;
        //加载该公司下的所有项目包括 下级公司项目
        let params = {page: 1, limit: 10000, comId: id};//请求参数
        proSearch(params, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.proData = result.data.result;
            if(this.option==1){
              this.proId =  parseInt(this.formObj.proId);
            }else{
              this.proClear();
            }

          }
        });
      },
      roleSelected:function(roleId) {
        this.parentId = roleId;
      },
      //清空项目
      proClear:function(){
        this.proId =null;
        return false;
      },
      doSubmit: function (option) {
        if(this.comId==0 || this.comId == null)
        {
          this.$message({
            message: "请选择所属公司",
            type: 'error'
          });
          return ;
        }
        this.formObj.funs = JSON.stringify(this.funOptionList);
        this.formObj.comId = this.comId;
        this.formObj.proId = this.proId;
        this.formObj.parentId = this.parentId;
        this.formObj.isManager = this.isManager;
        this.formObj.status = this.status;
        // console.log(this.formObj)
        this.$refs.formObj.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
              if (option == 0) {
                roleCreate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "添加成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              } else if (option == 1) {
                roleUpdate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "修改成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              }
            }).catch(() => {
            });
          }
        });
      },
      doCancel: function () {
        this.$emit('doCancel');
      },
      //加载功能数据
      loadNode1(node, resolve) {
        let roleId = 0;
        if (node.level > 0) {
          roleId = node.key;
        }
        let params = {id: roleId};//请求参数
        funs(params, this.GLOBAL.header).then(result => {
          if (result.success) {
            return resolve(result.data)
          }
        });
      },
      //功能选择
      appendFun: function (v, data, option) {
        //选中某个功能操作
        if (v) {
          if (this.funOptionList.length > 0) {
            let o = null;
            for (let i = 0; i < this.funOptionList.length; i++) {
              let keyCode = this.funOptionList[i].keyCode;
              if (keyCode == data.keyCode) {
                o = this.funOptionList[i];
                break;
              }
            }
            if (o != null) {
              o.option.push(option);
              o.funOption = o.option.join(',')
            } else {
              let obj = {keyCode: '', option: []};
              obj.keyCode = data.keyCode;
              obj.id = data.funId;
              obj.option.push(option);
              obj.funOption = obj.option.join(',')
              this.funOptionList.push(obj);
            }
          } else {
            let obj = {keyCode: '', option: []};
            obj.keyCode = data.keyCode;
            obj.id = data.funId;
            obj.option.push(option);
            obj.funOption = obj.option.join(',')
            this.funOptionList.push(obj);
          }
        }
        //取消选中
        else {
          if (this.funOptionList.length > 0) {
            let o = null;
            let n = null;
            for (let i = 0; i < this.funOptionList.length; i++) {
              let keyCode = this.funOptionList[i].keyCode;
              if (keyCode == data.keyCode) {
                o = this.funOptionList[i];
                n = i;
                break;
              }
            }
            if (o != null) {
              let index = o.option.indexOf(option);
              if (index > -1) {
                o.option.splice(index, 1)
                o.funOption = o.option.join(',')
              }
              if (o.option.length == 0) {
                this.funOptionList.splice(n, 1);
              }
            }
          }
        }
      },
    },
    mounted() {
      this.isShowTree = true;
      this.formObj = this.formData;

      this.isManager = this.formData.isManager + '';
      //添加表单初始化
      if(this.option==0){}
      //修改表单初始化
      if(this.option==1) {
         this.status = this.formData.status+'';
         if (typeof this.formObj.funs == 'string') {
           this.tempFunOptionList = JSON.parse(this.formObj.funs);
         }
         for(let i = 0 ; i < this.tempFunOptionList.length; i++){
           this.tempList[i] = this.tempFunOptionList[i].keyCode;
           this.funOptionList[i] = this.tempFunOptionList[i];
         }
         if(this.formObj.parentComName==null || this.formObj.parentComName==''){
           this.formObj.parentComName = this.GLOBAL.user.comName;
           this.formObj.parentComId = this.GLOBAL.user.comId;
         }
      }
    }
  }
</script>

<style scoped>
  .space {
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sysmanager/RoleForm.vue